module.exports = __webpack_public_path__ + "80bf7119f779d9544b4eff53bb51a3d0.fbx";